import apiClient, { ApiResponse, PaginatedResponse } from '../api/client';
import { Schedule, Part, Category } from '../types/models';

export interface CreateScheduleData {
  name: string;
  description?: string;
}

export interface CreatePartData {
  service_id: number;
  name: string;
  description?: string;
}

export interface CreateCategoryData {
  name: string;
  description?: string;
}

class HierarchyService {
  // Schedule endpoints
  async getSchedules(moduleId: number, page?: number): Promise<ApiResponse<PaginatedResponse<Schedule>>> {
    const params = page ? `?page=${page}` : '';
    return apiClient.get<PaginatedResponse<Schedule>>(`/admin/county/modules/${moduleId}/schedules${params}`);
  }

  async getSchedule(moduleId: number, id: number): Promise<ApiResponse<Schedule>> {
    return apiClient.get<Schedule>(`/admin/county/modules/${moduleId}/schedules/${id}`);
  }

  async createSchedule(moduleId: number, data: CreateScheduleData): Promise<ApiResponse<Schedule>> {
    return apiClient.post<Schedule>(`/admin/county/modules/${moduleId}/schedules`, data);
  }

  async updateSchedule(moduleId: number, id: number, data: Partial<CreateScheduleData>): Promise<ApiResponse<Schedule>> {
    return apiClient.put<Schedule>(`/admin/county/modules/${moduleId}/schedules/${id}`, data);
  }

  async deleteSchedule(moduleId: number, id: number): Promise<ApiResponse> {
    return apiClient.delete(`/admin/county/modules/${moduleId}/schedules/${id}`);
  }

  // Part endpoints
  async getParts(moduleId: number, page?: number): Promise<ApiResponse<PaginatedResponse<Part>>> {
    const params = page ? `?page=${page}` : '';
    return apiClient.get<PaginatedResponse<Part>>(`/admin/county/modules/${moduleId}/parts${params}`);
  }

  async getPart(moduleId: number, id: number): Promise<ApiResponse<Part>> {
    return apiClient.get<Part>(`/admin/county/modules/${moduleId}/parts/${id}`);
  }

  async createPart(moduleId: number, data: CreatePartData): Promise<ApiResponse<Part>> {
    return apiClient.post<Part>(`/admin/county/modules/${moduleId}/parts`, data);
  }

  async updatePart(moduleId: number, id: number, data: Partial<CreatePartData>): Promise<ApiResponse<Part>> {
    return apiClient.put<Part>(`/admin/county/modules/${moduleId}/parts/${id}`, data);
  }

  async deletePart(moduleId: number, id: number): Promise<ApiResponse> {
    return apiClient.delete(`/admin/county/modules/${moduleId}/parts/${id}`);
  }

  // Category endpoints
  async getCategories(moduleId: number, page?: number): Promise<ApiResponse<PaginatedResponse<Category>>> {
    const params = page ? `?page=${page}` : '';
    return apiClient.get<PaginatedResponse<Category>>(`/admin/county/modules/${moduleId}/categories${params}`);
  }

  async getCategory(moduleId: number, id: number): Promise<ApiResponse<Category>> {
    return apiClient.get<Category>(`/admin/county/modules/${moduleId}/categories/${id}`);
  }

  async createCategory(moduleId: number, data: CreateCategoryData): Promise<ApiResponse<Category>> {
    return apiClient.post<Category>(`/admin/county/modules/${moduleId}/categories`, data);
  }

  async updateCategory(moduleId: number, id: number, data: Partial<CreateCategoryData>): Promise<ApiResponse<Category>> {
    return apiClient.put<Category>(`/admin/county/modules/${moduleId}/categories/${id}`, data);
  }

  async deleteCategory(moduleId: number, id: number): Promise<ApiResponse> {
    return apiClient.delete(`/admin/county/modules/${moduleId}/categories/${id}`);
  }
}

export const hierarchyService = new HierarchyService();
export default hierarchyService;
